<a class="shop-view-link" (click)="onClick()">
  @if (!shopViewActivated) {
    {{ "shopView.activate" | cxTranslate }}
  }

  @if (shopViewActivated) {
    {{ "shopView.deactivate" | cxTranslate }}
  }
</a>
